import s from "./styles.module.sass";
import ExpandableText, { ExtraText } from "@shared/UI/ExpandableText";

type DescriptionProps = {
	description: string;
	audienceTexts: Array<string>;
};
const Description = ({ description, audienceTexts }: DescriptionProps) => {
	const courseAudience: ExtraText[] = [
		{
			id: 1,
			title: "Для кого подойдет этот курс?",
			text: audienceTexts,
		},
	];

	return (
		<section>
			<h2>Описание курса</h2>
			<div className={s.descriptionWrapper}>
				{description && (
					<ExpandableText
						id="course-descr"
						text={description}
						extraText={audienceTexts.length >= 1 ? courseAudience : []}
					/>
				)}
			</div>
		</section>
	);
};

export default Description;
